import React, { useEffect, useState } from 'react';
import MagazineService from '../../../services/magazine';
import { siteUrl } from "../../../utils/siteUrl";
import Button from '../../atoms/button/button';
import CommentsReport from '../../modals/comments-report/comments-report';
import './comments-articles.scss';

const CommentsArticle = (props) => {
    var homeLink = siteUrl + '/'

    const [currentPageComment, setCurrentPageComment] = useState(1)
    const [comentary, setComentary] = useState("")
    const [SummaryResponse, setsummaryResponse] = useState(null)
    const [limitPage, setLimitPage] = useState(0)
    const [disabledButton, setdisabledButton] = useState(false)

    const handleLoadSummary = () => {
        var currentPageCommentCopy = currentPageComment;
        var copyCommentsList = SummaryResponse;
        MagazineService.getComments("?contentId=" + props.idArticle + "&page=" + currentPageComment + "&size=2&country=" + process.env.COUNTRY_CODE).then(res => {
            copyCommentsList = copyCommentsList.concat(res.data)
            setsummaryResponse(copyCommentsList);
            setCurrentPageComment(currentPageCommentCopy + 1)
        }).catch(e => console.log(e))
    }
    const handleSendComment = () => {
        setdisabledButton(true)
        if (localStorage.getItem('TOKEN_INFO') === null) {
            // sessionStorage.setItem('NEXT_PAGE','/entre-nosotras/'+ props.slug)
            sessionStorage.setItem('COMMENT_ART', comentary)
            window.location.href = homeLink + 'login/'
        } else {
            var tokenId = JSON.parse(localStorage.getItem("TOKEN_INFO")).idToken;

            var config = {
                headers: {
                    Authorization: tokenId,
                }
            }
            var payload = {
                commentary: comentary,
                contentId: props.idArticle,
                country: process.env.COUNTRY_CODE
            }
            MagazineService.setComments(payload, config).then(res => {
                setComentary("");
                setdisabledButton(false)
                MagazineService.getComments("?contentId=" + props.idArticle + "&page=0&size=2&country=" + process.env.COUNTRY_CODE, config).then(res => {
                    setsummaryResponse(res.data)
                }).catch(e => console.log(e))
            }).catch(e => console.log(e))

        }
    }
    useEffect(() => {
        if (sessionStorage.getItem('COMMENT_ART') !== null) {
            setComentary(sessionStorage.getItem('COMMENT_ART'))
        }
        var config = null
        if (localStorage.getItem("TOKEN_INFO")) {
            var tokenId = JSON.parse(localStorage.getItem("TOKEN_INFO")).idToken;
            config = {
                headers: {
                    Authorization: tokenId,
                }
            }
        }

        MagazineService.getComments("?contentId=" + props.idArticle + "&page=0&size=2" + "&country=" + process.env.COUNTRY_CODE, config).then(res => {
            setsummaryResponse(res.data)
            setLimitPage(res.metadata.limit)
        }).catch(e => console.log(e))
    }, [])

    const handleReport = (commentaryId) => {
        if (localStorage.getItem('TOKEN_INFO') === null) {
            sessionStorage.setItem('NEXT_PAGE', '/magazin/nuestro-mundo/' + props.slug)
            sessionStorage.setItem('COMMENT_ART', comentary)
            window.location.href = homeLink + 'login/'
        } else {
            props.setModalState(<CommentsReport resetComentary={resetComentary} commentaryId={commentaryId} setModalState={props.setModalState} />)
        }
    }

    const resetComentary = () => {
        var config = null
        if (localStorage.getItem("TOKEN_INFO")) {
            var tokenId = JSON.parse(localStorage.getItem("TOKEN_INFO")).idToken;
            config = {
                headers: {
                    Authorization: tokenId,
                }
            }
        }

        MagazineService.getComments("?contentId=" + props.idArticle + "&page=0&size=2&country=" + process.env.COUNTRY_CODE, config).then(res => {
            setsummaryResponse(res.data)
            setLimitPage(res.metadata.limit)
        }).catch(e => console.log(e))
    }

    return (
        <div className="f-comment-article-section">
            <div className="f-comment-article-section-content">
                <p className="f-comment-article-section-content-title">Déjanos tus comentarios</p>

                <div className="f-comment-article-section-content-textarea">
                    <textarea maxLength="500" value={comentary} placeholder="Escribe tu comentario" onChange={e => setComentary(e.target.value)} />
                </div>
                <div onClick={handleSendComment} className={comentary && !disabledButton ? "f-comment-article-section-content-btn" : "f-comment-article-section-content-btn disable"}>
                    <Button title="Comentar" className="primary-pink" />
                </div>
                <div className="f-comments-list-container">
                    {SummaryResponse && SummaryResponse.map((comment, index) => {

                        return (
                            <div className="f-comment-container" key={index}>
                                <img
                                    className="f-profile-photo-comment"
                                    src={comment.profileImage}
                                    alt='Foto de perfil comentario'
                                />
                                <div>
                                    <div className="f-user-info-container">
                                        <label className="f-user-fullname">{comment.user}</label>
                                        <p className="f-user-comment">{comment.commentaryDetail}</p>
                                    </div>
                                    <div className="f-comment-container-report" onClick={() => handleReport(comment.commentaryId)}>
                                        <p>Denunciar</p>
                                        <span className="icon-block"></span>
                                    </div>
                                </div>
                            </div>
                        )
                    })}
                    {(currentPageComment < limitPage) && <div className="f-load-more">
                        <label className="f-more-elements-title" onClick={() => handleLoadSummary()}>
                            Cargar más
                            </label>
                    </div>}
                </div>
            </div>
        </div>
    )
}

export default CommentsArticle
